<form #standardForm="ngForm">

  <!-- Step 1: Choose Report Type -->
  <div class="mb-3">
    <label class="form-label">Choose Report Type<span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="standardFormData.selectedType" name="selectedType"
            (change)="onFormChange()">
      <option value="" disabled selected>Select a report type</option>
      <option value="food">Annual Food Waste Audit</option>
      <option value="annual">Annual School Profile</option>
      <option value="project">Project</option>
      <option value="watershedProject">Annual Watershed Education Data by Project</option>
      <option value="watershedSchool">Annual Watershed Education Report by School-Completed Status</option>
    </select>
  </div>

  <!-- Step 2: Year -->
  <div class="mb-3" *ngIf="standardFormFlags.showYear">
    <label class="form-label">
      {{ (standardFormData.selectedType === 'watershedProject' || standardFormData.selectedType === 'watershedSchool')
      ? 'Reporting Year Nov 1 - Oct 31'
      : 'Annual School Year' }}
      <span class="required">*</span>
    </label>

    <select class="form-select"
            [(ngModel)]="standardFormData.schoolYear"
            name="schoolYear"
            (change)="onYearChange()">
      <option value="" disabled>Select year</option>
      <option *ngFor="let year of getYears()" [value]="year">
        {{ year }}
      </option>
    </select>
  </div>

  <!-- Step 3: Choose Scope -->
  <div class="mb-3" *ngIf="standardFormFlags.showScope">
    <label class="form-label">Choose From <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="standardFormData.scope" name="scope" (change)="onScopeChange()">
      <option value="" disabled selected>Select</option>
      <option value="school">School</option>
      <option value="cluster">Cluster</option>
      <option value="all">All Schools</option>
    </select>
  </div>

  <!-- Conditional School selection -->
  <div class="mb-3"
       *ngIf="standardFormFlags.showSelection && standardFormData.scope !== 'cluster' && standardFormData.scope != 'all'">
    <label class="form-label">{{ standardFormData.selectionLabel }} <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="standardFormData.selection" name="selection">
      <option value="" disabled selected>Select option</option>
      <option *ngFor="let opt of standardFormData.selectionOptions" [value]="opt">{{ opt }}</option>
    </select>
  </div>

  <!-- Conditional Cluster selection-->
  <div class="mb-3" *ngIf="standardFormData.scope === 'cluster'">
    <label class="form-label">{{ standardFormData.selectionLabel }} <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="standardFormData.selection" name="selection">
      <option value="" disabled selected>Select option</option>
      <option *ngFor="let opt of standardFormData.selectionOptions" [value]="opt">{{ opt }}</option>
    </select>
  </div>

  <!-- Generate Button -->
  <div *ngIf="standardFormFlags.showSelection || standardFormData.scope === 'all'">
    <button type="button" class="btn generate-btn" [disabled]="!canGenerate()" (click)="generateExcelReport()">
      Report
    </button>
  </div>
</form>
